// extracted by mini-css-extract-plugin
module.exports = {"title":"title--8aSBg","message":"message--mmuuW"};